//import createHistory from "history/createBrowserHistory";
import { /*createBrowserHistory,*/ createHashHistory  } from "history";
export default createHashHistory();